import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, QueryList, ViewChildren, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { IrisDmsFilesSandbox } from '../../../sandbox/dms-files.sandbox';
import { IrisDMSFile, IrisDMSFileI } from '../../../models/IrisDMSFile';
import { AuthFacade } from '@iris/modules/auth/utils/auth.facade';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, take, tap } from 'rxjs';
import { IrisLoaderModule } from '@iris/common/modules/loader';
import {
  ConfirmByKeypressDirective,
  SkModalBase,
  SkModalContentComponent,
} from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-office-editor',
  imports: [
    TranslateModule,
    SkModalContentComponent,
    IrisLoaderModule,
    ConfirmByKeypressDirective,
  ],
  templateUrl: './office-editor.component.html',
  styleUrl: './office-editor.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisOfficeEditorComponent extends SkModalBase<IrisOfficeEditorComponent, void> implements AfterViewInit {
  private readonly authFacade = inject(AuthFacade);
  readonly data = inject<{
    file: IrisDMSFileI;
  }>(MAT_DIALOG_DATA);
  private readonly dmsFilesSandbox = inject(IrisDmsFilesSandbox);

  @ViewChildren('officeForm') officeForm: QueryList<ElementRef<HTMLFormElement>>;

  private readonly token$ = this.authFacade.actualToken(true).pipe(
    filter(Boolean),
    take(1),
  );
  readonly accessToken = toSignal(this.token$);
  readonly accessTokenTtl = this.authFacade.accessTokenExpiredAt;

  get fileName(): string {
    return this.data.file.name;
  }

  get wopiEditUrl(): string {
    return new IrisDMSFile(this.data.file).composeWopiEditUrl(this.dmsFilesSandbox.getWopiUrl(this.data.file.id));
  }

  ngAfterViewInit(): void {
    this.token$.pipe(
      tap(() => {
        setTimeout(() => {
          this.officeForm.first?.nativeElement.submit();
        });
      }),
    ).subscribe();
  }
}
